<template>
  <tg-toolbar
    ref="toolbar"
    class="tg-app-bar"
    :height="height"
    :size="size"
    :prominent="prominent"
    :floating="floating"
  >
    <tg-toolbar-btn
      @click.native="handleBarsClick"
      class="tg-app-bar--bars"
      v-if="!!icon"
      :icon="icon"
      size="sm"
    >
      <slot name="icon"></slot>
    </tg-toolbar-btn>
    <tg-toolbar-title>
      <slot>{{ title }}</slot>
    </tg-toolbar-title>
    <div class="spacer"></div>
    <slot name="float"></slot>
    <slot name="tools"></slot>
    <template v-if="type === 'dialog'">
      <tg-toolbar-btn icon="times" @click="handleClose"></tg-toolbar-btn>
    </template>
    <template v-if="!!$scopedSlots.extension" v-slot:extension>
      <slot name="extension"></slot>
    </template>
  </tg-toolbar>
</template>

<script>
import TgToolbar from "@/components/bars/TgToolbar";
import TgToolbarBtn from "@/components/bars/TgToolbarBtn";
import TgToolbarTitle from "@/components/bars/TgToolbarTitle";
import { toolAppProps } from "./utils";

export default {
  components: {
    TgToolbar,
    TgToolbarBtn,
    TgToolbarTitle,
  },
  props: toolAppProps,
  computed: {
    icon() {
      switch (this.type) {
        case "sub":
          return "angle-left";
        default:
          return "bars";
      }
    },
  },
  methods: {
    handleBarsClick() {
      if (this.type == "sub") {
        this.$router.go(-1);
      } else {
        this.$emit("on-bars-click", this.type);
      }
    },
    handleClose() {
      this.$emit("on-close");
    },
    parseExtendheight() {
      this.$refs.toolbar.parseExtendheight();
    },
  },
};
</script>